import { Dynamic } from 'solid-js/web';
import type { IconComponent } from '@bbr/icons';
import type { ParentProps } from 'solid-js';

export function Card(props: ParentProps) {
	return (
		<div class="relative flex size-full gap-4 rounded-lg border border-zinc-200 bg-zinc-100 p-4 transition-all hover:-translate-y-1 hover:border-yellow-500 dark:border-zinc-800 dark:bg-zinc-800 dark:hover:border-yellow-600 dark:hover:bg-zinc-800">
			{props.children}
		</div>
	);
}

export function CardLayoutIcon(props: ParentProps<{ icon: IconComponent }>) {
	return (
		<>
			<span class="grid size-12 shrink-0 place-items-center rounded-lg bg-yellow-100 text-2xl text-yellow-600">
				<Dynamic component={props.icon} />
			</span>
			<div class="flex w-full flex-col gap-4">{props.children}</div>
		</>
	);
}

export function CardContent(props: ParentProps<{ title?: string; supTitle?: string }>) {
	return (
		<div class="flex flex-col">
			<p class="text-sm font-bold text-yellow-600">{props.supTitle}</p>
			<p class="font-semibold">{props.title}</p>
			<div class="text-sm text-wrap">{props.children}</div>
		</div>
	);
}

Card.Content = CardContent;
